import styled from 'styled-components';
import { COLOR_GREY } from '../../config';

export const NameTag = styled.div`
    width: 16rem;
    height: 6rem;
    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    display: flex;
    align-items: center;
    padding-left: 1.6rem;
    box-sizing: border-box;
    font-size: 1.5rem;
    color: ${COLOR_GREY};
`;
